import { environment } from './../../../environments/environment';

export const WEB_API = `${environment.api}/sgf-inativos`;
